import React, { FC } from "react";

import { useInvoiceFiltersController } from "../../../hooks/useInvoiceFiltersController";
import { InvoiceFiltersBase } from "./InvoiceFiltersBase";

type Props = {
  controller: ReturnType<typeof useInvoiceFiltersController>;
};

export const ContactInvoicesFilters: FC<Props> = ({ controller }) => {
  return (
    <InvoiceFiltersBase
      showFilters={["status", "assignee", "invoice-date", "label"]}
      filter={controller.filter}
      setFilter={controller.setFilter}
      filterByStatus={controller.filterByStatus}
      setFilterByStatus={controller.setFilterByStatus}
      filterByUser={controller.filterByUser}
      setFilterByUser={controller.setFilterByUser}
      filterByContact={controller.filterByContact}
      setFilterByContact={controller.setFilterByContact}
      filterByLabel={controller.filterByLabel}
      setFilterByLabel={controller.setFilterByLabel}
      usersOptions={controller.usersOptions}
      labelOptions={controller.labelOptions}
      isLoadingUsers={controller.isLoadingUsers}
    />
  );
};
